module.exports = __webpack_public_path__ + "img/lottie-off.079b42d.png";